import FJTextStyleShadow from './FJTextStyleShadow';
import FJTextStyleGlow from './FJTextStyleGlow';
import FJTextStyleHollow from './FJTextStyleHollow';
import FJTextStyleBorder from './FJTextStyleBorder';
import FJTextStyleBorderAndShadow from './FJTextStyleBorderAndShadow';
import FJTextStyleNeon from './FJTextStyleNeon';
import FJTextStyleNone from './FJTextStyleNone';
import FJTextStyleSplice from './FJTextStyleSplice';
import FJTextStyleEcho from './FJTextStyleEcho';
import FJTextStyleUnderline from './FJTextStyleUnderline';
import FJTextStyleDoubleOutline from './FJTextStyleDoubleOutline';
import FJTextStyleGlitch from './FJTextStyleGlitch';
import FJTextStyle3D from './FJTextStyle3D';

const TEXT_STYLES = {
    NONE: 'NONE',
    SHADOW: 'SHADOW',
    GLOW: 'GLOW',
    HOLLOW: 'HOLLOW',
    BORDER: 'BORDER',
    BORDER_AND_SHADOW: 'BORDER_AND_SHADOW',
    NEON: 'NEON',
    SPLICE: 'SPLICE',
    ECHO: 'ECHO',
    UNDERLINE: 'UNDERLINE',
    DOUBLE_OUTLINE: 'DOUBLE_OUTLINE',
    GLITCH: 'GLITCH',
    THREE_D: 'THREE_D',
};

let FJTextStyleManager = (function () {
    // style列表
    let _styles = [
        {
            name: TEXT_STYLES.NONE,
            localName: 'none',
            Constructor: FJTextStyleNone,
        },
        {
            name: TEXT_STYLES.SHADOW,
            localName: 'shadow',
            Constructor: FJTextStyleShadow,
        },

        {
            name: TEXT_STYLES.BORDER,
            localName: 'border',
            Constructor: FJTextStyleBorder,
        },
        {
            name: TEXT_STYLES.HOLLOW,
            localName: 'hollow',
            Constructor: FJTextStyleHollow,
        },
        {
            name: TEXT_STYLES.GLOW,
            localName: 'glow',
            Constructor: FJTextStyleGlow,
        },
        {
            name: TEXT_STYLES.BORDER_AND_SHADOW,
            localName: 'border-shadow',
            Constructor: FJTextStyleBorderAndShadow,
        },
        {
            name: TEXT_STYLES.NEON,
            localName: 'neon',
            Constructor: FJTextStyleNeon,
        },
        {
            name: TEXT_STYLES.SPLICE,
            localName: 'splice',
            Constructor: FJTextStyleSplice,
        },
        {
            name: TEXT_STYLES.ECHO,
            localName: 'echo',
            Constructor: FJTextStyleEcho,
        },
        {
            name: TEXT_STYLES.UNDERLINE,
            localName: 'underline',
            Constructor: FJTextStyleUnderline,
        },
        {
            name: TEXT_STYLES.DOUBLE_OUTLINE,
            localName: 'double-outline',
            Constructor: FJTextStyleDoubleOutline,
        },
        {
            name: TEXT_STYLES.THREE_D,
            localName: 'three-d',
            Constructor: FJTextStyle3D,
        },
        {
            name: TEXT_STYLES.GLITCH,
            localName: 'glitch',
            Constructor: FJTextStyleGlitch,
        },
    ];

    let getStyle = name => {
        return _styles.find(item => {
            return item.name.toLowerCase() === name.toLowerCase();
        });
    };

    let manager = {
        allStyles: function () {
            return _styles;
        },
        createStyle: function (name, options) {
            let style = getStyle(name);
            if (style) {
                return new style.Constructor({ ...options, type: style.name });
            }

            return null;
        },
        TEXT_STYLES: TEXT_STYLES,
    };

    return manager;
})();

export default FJTextStyleManager;
